<template>
    <div class="app-container flex-grow-1 d-flex flex-column" :class="{ 'mt-0': !isShow }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'MobileContainer',

    computed: {
        isShow() {
            return window.self === window.top;
        }
    }
};
</script>

<style lang="scss" scoped>
.app-container {
    position: relative;
    margin-top: 60px;
    display: flex;
    flex-direction: column;
}
.mt-0 {
    margin-top: 0;
}
</style>
